module.exports = __webpack_public_path__ + "img/belgium-breast-cancer-female.aa003986.png";